import React, { useState, useEffect } from 'react'
import InputCard from './Card'
import './style.css'
// import AccountAddedSuccessLoder from '../cards/AccountAddedSuccessLoder'
// import { FaBars } from "react-icons/fa";
import { useAuth } from '../../../contexts/AuthContext';
import { AccountManager } from '../../../services/users';
//import { AccountContext } from '../../../contexts/AccountContext'

import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';





export function AccountAddedSuccessLoder ({open, close, accountLoader}) {
    // const [open, setOpen] = useState(false);

    // const handleClickOpen = () => {
    //     setOpen(true);
    //   };
    
    //   const handleClose = () => {
    //     setOpen(false);
    //   };
    console.log(open)

    return (
      <Dialog
          open={open}
          onClose={close}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent >
              {accountLoader ? <CircularProgress /> :  
              <Box>
                <DialogContentText id="alert-dialog-description" sx={{color: "green"}}>
                  Account added successfully!
                </DialogContentText> 
                  <Box sx={{ textAlign: "center", padding: "10px"}}>
                <Button variant="contained" onClick={close}>Ok</Button></Box>
              </Box>}
           
          </DialogContent>
          
        </Dialog>
    )
  }

 


  

  export function DeleteAccountSuccess ({open, close, deletedAccountLoader}) {
    // const [open, setOpen] = useState(false);

    // const handleClickOpen = () => {
    //     setOpen(true);
    //   };
    
    //   const handleClose = () => {
    //     setOpen(false);
    //   };
    console.log(open)

    return (
      <Dialog
          open={open}
          onClose={close}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent >
              {deletedAccountLoader ? <CircularProgress /> :  
                <Box>
                  <DialogContentText id="alert-dialog-description" sx={{color: "green", textAlign: "center"}}>
                    Account deleted successfully!
                  </DialogContentText>  
                  <Box sx={{textAlign: "center", padding: "10px"}}><Button variant="contained" onClick={close}>Ok</Button></Box>
                </Box>}
           
          </DialogContent>
         
        </Dialog>
    )
  }



const accountManager = new AccountManager()

export default function Account() {

    //static contextType = AccountContext


    const [state, setState] = useState([])
    const [accountLoader, setAccountLoader ] = useState(true)
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = () => {
        setOpen(false);
      };
    
      const [deletedAccountLoader, setDeletedAccountLoader ] = useState(true)
     
      const [deletedOpen, setDeletedOpen] = useState(false);
      const handleDeletedOpen = () => {
        setDeletedOpen(true);
      };
    
      const handleDeletedClose = () => {
        setDeletedOpen(false);
      };

      
   

    const { currentUser } = useAuth()

    accountManager.init(currentUser)

   
    //implememnt componentDidMount to get users accounts {}
    /*componentDidMount(){
        
        this.setState({details:this.context.accounts})
    }*/

    const [loader, setLoader] = useState(false)
    useEffect(() => {
        return accountManager.getAccounts((data) => {
            setState(data)
        }).catch(e=>{
            console.log('getting account error', e.message);
        }).finally(()=>{
            setLoader(true)
        })
    }, [])

    function deleteCard(index) {
        setDeletedAccountLoader(true)
        accountManager.removeAccount(state[index]).catch((e)=>{
            console.log('account remove error:-->', e.message)
            setDeletedAccountLoader(false)
        }).then(()=>{
            const accounts = [...state]
            accounts.splice(index,1)
            setDeletedAccountLoader(false)
            setState(accounts)
           
        }) // handle error and loader ??await
    }

    async function handleSubmit(detail) {
        console.log(detail)
        setAccountLoader(true)
        await accountManager.addAccount(detail).catch((e) => {
            console.log(e);
            setAccountLoader(false)
        }).then((data) => {
            setState([...state, data])
            setAccountLoader(false)
        })
        //setState({ details: [...state.details, detail]})
    }

    //        const { details } = state
    return (
        <>

            <InputCard Loader={loader} userDetails={state}
                deleteCard={deleteCard}
                handleSubmit={handleSubmit}
                handleClickOpen={handleClickOpen}
                handleDeletedOpen={handleDeletedOpen}
            />


            <AccountAddedSuccessLoder 
                open={open}
                close={handleClose}
                accountLoader={accountLoader}
                
            />

            <DeleteAccountSuccess 
            deletedAccountLoader={deletedAccountLoader}
            open={deletedOpen}
            close={handleDeletedClose}
            />
           


        </>
    )
}
